import React from 'react';
import './cn-demo-description.scss';
var CnDemoDescription = function (props) {
    return React.createElement("div", { className: "cn-ui-m-demo-description" }, props.children);
};
export default CnDemoDescription;
